export default __webpack_public_path__ + "static/media/bank-icon.bf77147b.svg";